<template>
  <div class="view">
    <container>
      <h2 class="color-tint pointer-hover" v-link="{name: 'new-team'}">+ Tilføj hold</h2>
      <p>Når du har oprettet et hold kan det ikke slettes igen.
      Dette er et sikkerhedshensyn så hold ikke mistes ved fejl, hvis der er flere brugere på samme login.
Du kan sende en mail til <a class="color-tint" href="mailto:support@mindsocial.dk">support@mindsocial.dk</a> og bede os fjerne holdet fra listen.
</p>
      <ul>
        <template v-for="team in teams">
        <list-item v-link="{name: 'team', params: {team: team.id}}">
          {{team.name}}
        </list-item>
        </template>
      </ul>
    </container>
  </div>
</template>

<script>
import view from '../mixins/view'
// Components
import ListItem from 'components/ListItem'
import FlipButton from 'components/FlipButton'

// Getters
import { allTeams } from '../vuex/teams/getters'

// Actions
import { getAllTeams } from 'state/teams/actions'

export default {
  name: 'TeamsView',
  mixins: [view],
  components: {
    ListItem,
    FlipButton
  },
  vuex: {
    getters: {
      teams: allTeams
    },
    actions: {
      getAllTeams
    }
  },
  ready () {
    this.getAllTeams()
  }
}
</script>

<style lang="scss" scoped>
.view {
  flex: 1;
  min-height: 100%;
}
p {
  max-width: 50%;
  margin-top: 2rem;
}
ul {
  margin-top: 4rem;
}
</style>



// WEBPACK FOOTER //
// Teams.vue?7b1b831e